import { RootState } from '../index';

export const selectSubmission = (state: RootState) => (state.submission.status === 'LOADED' ? state.submission.data : null);

export const selectSubmissionLoadingStatus = (state: RootState) => state.submission.status;
